import events from '../events';
import {isFunction} from '../lang/is';
import {animated} from './execution';

let
    handled = false;

const
    publisher = events('mutated'),
    publish = publisher.publish,
    mutationSubscribe = publisher.subscribe,

    update = () => {
        publish.mutated();
    },

    MutationObserver = (
        window.MutationObserver ||
        window.WebKitMutationObserver);

if (isFunction(MutationObserver)) {
    const
        observer = (
            new MutationObserver(
                () => {
                    if (!handled) {
                        handled = true;
                        animated(() => {
                            handled = false;
                            update();
                        });
                    }
                }));

    observer.observe(
        document.documentElement,
        {childList: true, subtree: true});
}

export {
    mutationSubscribe
};
